import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Link } from 'react-router'

export const AccountInfoWrapStyled = styled.div({
  marginBottom: '1.6rem',

  '& > div': {
    minWidth: '50%',
  },
})

export const AccountNameLabelStyled = styled.div({
  fontSize: '2rem',
  fontWeight: '700',
  color: hexColors.studio,
})

export const AccountNumberLabelStyled = styled.div({
  fontSize: '1.2rem',
  fontWeight: '300',
  color: hexColors.nero,
})

export const SeparatorStyled = styled.hr({
  margin: '1rem 0',
  border: 0,
  height: 0,
  borderBottom: '1px solid ' + hexColors.grey3,
})

export const DepositWithdrawSectionStyled = styled.div({
  display: 'flex',
  '*:not(:last-child)': {
    marginRight: '1.7rem',
  },
})

export const ItemContainerStyled = styled.div({
  alignItems: 'center',
  color: hexColors.jacarta,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: '500',
  justifyContent: 'space-between',
  marginBottom: '0.25rem',
})

export const LinkStyled = styled(Link)({
  alignItems: 'center',
  color: hexColors.jacarta,
  display: 'inline-flex',
  fontSize: '1.4rem',
  fontWeight: '500',
  justifyContent: 'space-between',
  padding: '0.5rem 0',
  textDecoration: 'none',
  width: '100%',
})

export const LogoutLinkStyled = styled(LinkStyled)({
  color: hexColors.crimson,

  // The logout link has no href associated but does a POST request instead
  // So we add a pointer as the cursor to indicate to the user it's still clickable
  cursor: 'pointer',
  justifyContent: 'flex-start',

  '& svg': {
    verticalAlign: 'middle',
    marginRight: '0.8rem',
    marginTop: '-0.2rem',
  },
})
